export default __webpack_public_path__ + "static/media/shareBackground.ffc09bb9.svg";